export default __webpack_public_path__ + "static/media/8.a511f61c.PNG";